<template>
    <div class="__dashboard_layout">
        <PurgeCssComponent />
        <HeaderComponent
            v-model="openSidebar"
            :current-sidebar="currentSidebar"
        />
        <SidebarComponent
            v-if="!isInitialLandingPage"
            v-model="openSidebar"
            @current-sidebar="onSetCurrentSidebar($event)"
        />
        <main
            class="__dashboard_content"
            :class="{ 'lg:pl-60': !isInitialLandingPage }"
        >
            <div class="py-6">
                <div
                    v-if="!isInitialLandingPage && !_.isEmpty(currentSidebar)"
                    class="__container search__header"
                >
                    <div class="__page_name" :class="(router.currentRoute.value.name === 'report' ? 'mt-2' : '')">
                        <span
                            v-if="currentSidebar.dimension"
                        >
                            <span class="text-gray-900">{{ dimensionName.value || "" }}</span>
                            <span v-if="pageName === 'template_report' && dimensionName.sub" class="text-gray-500"> <span class="text-3xl" style="font-weight:100;"> | </span> {{ dimensionName.sub }} </span>
                        </span>

                        <div v-if="currentSidebar.metric" class="spacer" />

                        <span v-if="currentSidebar.metric">
                            {{ currentSidebar.metric.name }}
                        </span>
                    </div>
                    <FiltersComponent :current-sidebar="currentSidebar" />
                </div>
                <div v-if="reportsData.applied_filters" class="__container applied_filters mt-4" style="margin-bottom:-20px">
                    <div class="flex flex-wrap items-center">
                        <div class="py-1 my-1 text-gray-500">Applied Filters:</div>
                        <div class="flex items-center">
                            <div class="flex flex-wrap items-center transition delay-500 ease">
                                <div
                                    v-for="(item, index) in reportsData.applied_filters"
                                    :key="index"
                                    class="applied__filters"
                                    :class="appliedFilterClass === index ? 'hover-no-ellipsis' : ''"
                                    @mouseenter="onFilterHover(index)"
                                    @mouseleave="onFilterHover(null)"
                                >
                                    {{ item }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="__container">
                    <div class="my-4 ">
                        <div class="rounded-lg">
                            <main>
                                <slot />
                            </main>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import { ref, computed, defineAsyncComponent, watchEffect } from "vue";
import { HeaderComponent, SidebarComponent } from "@CommonComponents";
import useAnalytics from "@Functions/useAnalytics.js";
import { useRouter, useRoute } from 'vue-router'
import { useStore } from "vuex";
const FiltersComponent = defineAsyncComponent(() =>
    import("./components/filters/index.vue")
);

export default {
    name: "DashboardLayoutComponent",
    components: {
        HeaderComponent,
        SidebarComponent,
        FiltersComponent,
    },
    emits: [ "on-set-current-sidebar" ],
    setup(props, { emit }) {
        const currentSidebar = ref();

        const openSidebar = ref(false);
        const router = useRouter();
        const route = useRoute();
        const pageName = route.name
        const store = useStore();
        const reportsData = computed(() => {
            return store.getters["Reports/getReport"];
        });
        const { currentRoute } = useAnalytics();
        const isInitialLandingPage = computed(
            () => currentRoute.value.name === "initial-page"
        );
        const appliedFilterClass = ref(null);

        // COMPONENT PROPERTIES

        const pageTitle = computed(() => {
            return window.Subscription.page_title;
        });

        const onSetCurrentSidebar = async (val) => {
            emit("on-set-current-sidebar", val);
            currentSidebar.value = val;
        };
        const onFilterHover = (index) => {
            appliedFilterClass.value = index
        }

        const dimensionName = computed(() => {
            return {
                value: currentSidebar.value?.dimension.name,
                sub: reportsData.value?.title
            }
        })

        watchEffect(() => {
            if (route.name !== 'template_report') {
                store.commit("Reports/setReportData", {})
            }
        });

        return {
            currentSidebar,
            pageTitle,
            openSidebar,
            onSetCurrentSidebar,
            router,
            isInitialLandingPage,
            dimensionName,
            reportsData,
            appliedFilterClass,
            onFilterHover,
            pageName
        };
    },
};
</script>

<style lang="scss">
.__dashboard_layout {
    @apply min-h-screen;
    .__dashboard_content {
        @apply flex-1;
    }
    .__container {
        @apply mx-auto px-8;
    }
    .search__header {
        @apply lg:flex justify-between items-center;
        h1 {
            @apply xl:text-2xl text-xl leading-7 font-bold text-gray-500;
        }
        .filter-wrapper {
            @apply flex sm:justify-end justify-center lg:mt-0 mt-3;
            .search_params {
                min-width: 62px;
                .reset-btn {
                    @apply pl-4 text-primary font-medium cursor-pointer;
                }
            }
        }
    }
    .applied_filters {
        @apply text-sm font-semibold;
    }
    .__page_name {
        min-width: 50%;
        @apply xl:text-2xl text-xl leading-7 font-bold items-center flex lg:w-1/2 w-full text-gray-500;
        .spacer {
            @apply bg-gray-400;
            height: 0.5px;
            width: 4%;
            transform: rotate(90deg);
        }
    }
    .search_options {
        @apply flex items-center;
        .primary_text {
            @apply text-primary font-medium cursor-pointer;
        }
        .spacer {
            @apply bg-gray-300 pr-4;
            height: 0.5px;
            transform: rotate(90deg);
        }
    }
    .applied__filters {
        @apply mx-2 my-1 rounded-full inline-block max-w-sm font-normal truncate;
        background: #E0E7FF;
        font-size: 10px;
        padding: 5px 15px;
    }
    .hover-no-ellipsis:hover {
        overflow: visible;
        text-overflow: clip;
        white-space: normal;
    }
}
</style>
